<template>
  <div class="public-layout">
    <router-view></router-view>
  </div>
</template>

<style scoped>
.public-layout {
  min-height: 100vh;
  background: var(--bg-subtle);
}
</style>
